import '../../App.css';
export const ReportIncident = () =>{
    return(
        <div>
            <h1><a href="https://forms.gle/RcUSKK4pCc1Fy95V7" target="/blank" className="report">Report an Incident</a></h1>
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdPC2bR9Ek-NOLMVGULCEWgagBFAvPJkVNtn-FXu3uO_pi8_A/viewform?embedded=true" width={640} height={1200} frameBorder={0} marginHeight={0} marginWidth={0} title="reportincident">Loading…</iframe>
        </div>
    );
}